import { ThemeProvider } from 'styled-components';

import { lightTheme } from 'theme';

import { PRO_HERO_HIGHLIGHTS, PRO_PROFILE } from '../constants';
import * as styled from '../styles/pro-hero';
import { ProfileCard } from './profile-card';

type Props = {
  onPrimaryCta: () => void;
  onSeeRealPage: () => void;
};

export const ProHero = ({ onPrimaryCta, onSeeRealPage }: Props) => (
  <styled.Wrap>
    <styled.Left>
      <styled.Badge>
        <styled.BadgeDot />
        <styled.BadgeLabel>Free while we&apos;re building</styled.BadgeLabel>
      </styled.Badge>

      <styled.Heading>
        One link that gets you <em>booked</em>.
      </styled.Heading>

      <styled.Description>
        Your prices, your past work, your reviews and your calendar on one page. Put the link in
        your bio, or{' '}
        <strong>let clients find you on the Kudable marketplace</strong>.
      </styled.Description>

      <styled.CtaRow>
        <styled.PrimaryCta type="button" onClick={onPrimaryCta}>
          Create your free page
        </styled.PrimaryCta>
        <styled.SecondaryCta type="button" onClick={onSeeRealPage}>
          See a real page
        </styled.SecondaryCta>
      </styled.CtaRow>

      <styled.FeatureStrip>
        {PRO_HERO_HIGHLIGHTS.map((highlight) => (
          <styled.FeatureItem key={highlight.title}>
            <styled.FeatureTitle>{highlight.title}</styled.FeatureTitle>
            <styled.FeatureDescription>{highlight.description}</styled.FeatureDescription>
          </styled.FeatureItem>
        ))}
      </styled.FeatureStrip>
    </styled.Left>

    <ThemeProvider theme={lightTheme}>
      <ProfileCard data={PRO_PROFILE} />
    </ThemeProvider>
  </styled.Wrap>
);
